import { render, staticRenderFns } from "./PoliciesList.vue?vue&type=template&id=18605bac&scoped=true&"
import script from "./PoliciesList.vue?vue&type=script&lang=ts&"
export * from "./PoliciesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18605bac",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18605bac')) {
      api.createRecord('18605bac', component.options)
    } else {
      api.reload('18605bac', component.options)
    }
    module.hot.accept("./PoliciesList.vue?vue&type=template&id=18605bac&scoped=true&", function () {
      api.rerender('18605bac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/PoliciesList.vue"
export default component.exports